import { Society } from 'types';
import getSocietyLogoSrc from 'modules/_shared/components/Logos/getSocietyLogo';

export const generateSendReminderBody = (
  actualSociety: Society
) => `<div class="main" style="padding: 24px">
        <div style="background: #f5f6fa; font-family: Roboto; font-size: 14px; line-height: 22px; font-weight: 400; color: #8094ae; width: 100%; text-align: center;">
          <a href="https://www.sttok.com">
            <img src="${getSocietyLogoSrc(
              actualSociety
            )}" alt="logo" style="height: 40px; margin-top: 2.75rem"/>
          </a>
          <p style="font-size: 13px; color: #6576ff; padding-top: 6px; margin-top: 0; padding-bottom: 24px;">
            Gestión de Socios
          </p>
          <div class="email-body" style="width: 96%; max-width: 620px; text-align: left; margin: 0 auto; padding: 1.75rem 2.75rem; background: #ffffff;">
            <h2 style="font-family: Nunito, sans-serif; font-size: 18px; color: #6576ff; font-weight: 600; margin: 0; line-height: 1.4; margin: 10px 0; padding-bottom: 15px; text-align: left;">
              Recordatorio de Firma de Carta de Invitación de ${
                actualSociety.name
              }
            </h2>
            <p style="text-align: left;">Apreciado beneficiario, recuerda que tienes cartas de invitación pendientes de firma, por favor, no te demores en completarla.</p>
            <p style="text-align: justify">
              En tu bandeja de entrada puedes buscar por el nombre del plan y localizarás las cartas correspondientes.
            </p>
          </div>
          <p style="padding-bottom: 2.75rem; padding-top: 2.75rem; margin: 0">
            Correo enviado por <a style="color: #6576ff; text-decoration: none" href="https://sttok.com/">sttok.com</a> Puede contactar en <a href="mailto:info@sttok.com" target="_blank">info@sttok.com</a>
          </p>
        </div>
      </div>`;
